<template>
  <Modal
    v-model="visible"
    title="选择贴纸"
    :width="1200"
    :mask-closable="false"
    :closable="false"
    class-name="vertical-center-modal"
    @on-visible-change="bindGetData"
  >
    <Form inline style="padding: 0 5px">
      <FormItem :label-width="0">
        <Input v-model="keyword" placeholder="请输入素材名称" search @on-search="filterQuery" />
      </FormItem>
      <FormItem :label-width="50" label="设计师">
        <el-select
          v-model="designerId"
          :popper-append-to-body="false"
          collapse-tags
          filterable
          clearable
          placeholder="全部"
          style="width: 190px"
        >
          <el-option v-for="label in operatorData" :key="label.id" :value="label.id" :label="label.name"></el-option>
        </el-select>
      </FormItem>
      <FormItem :label-width="40" label="尺寸">
        <el-select v-model="wide" style="width: 100px">
          <el-option :value="1" label="456 X 300"></el-option>
          <el-option :value="2" label="1280 X 720"></el-option>
          <el-option :value="3" label="720 X 1280"></el-option>
          <el-option :value="0" label="全部"></el-option>
        </el-select>
      </FormItem>
      <FormItem :label-width="0">
        <Button type="primary" size="small" class="m-search-btn" @click="filterQuery">查询</Button>
      </FormItem>
    </Form>
    <div v-loading="show" class="image-box">
      <template v-if="caohuaMedia.length">
        <div class="image-wrapper" v-for="(item, idx) in caohuaMedia" :key="item.id || idx" @click="selectWrap(idx)">
          <div class="c-item-img" v-for="(t, id) in item.items" :key="id">
            <div class="c-item-bg"></div>
            <div class="image-item">
              <img :src="t.cover_url" :class="{ 'vertical-img': t.height < (t.width * 157) / 279 }" />
              <Row :gutter="12" class-name="c-item-title">
                <Col span="17" class-name="c-hover-l">
                  <Tooltip :content="t.name" transfer placement="top-start"
                    ><span>{{ t.name }}</span></Tooltip
                  >
                </Col>
                <Col span="7" class-name="c-hover-r">
                  <span>{{ t.size | fileSize }}</span>
                </Col>
              </Row>
              <span class="image-hover-txt">{{ t.width }}×{{ t.height }}</span>
            </div>
            <span v-if="item.check" class="image-check">
              <Icon type="md-checkmark-circle" size="24" color="#00FA9A" />
            </span>
          </div>
        </div>
      </template>
      <no-data v-else />
    </div>
    <Page
      v-if="total"
      :current.sync="pageIndex"
      :total="total"
      :page-size="pageSize"
      size="small"
      class="page-index"
      show-total
      @on-change="changePageIndex"
    />
    <template slot="footer">
      <Button type="default" size="small" @click="visible = false">取消</Button>
      <Button type="primary" size="small" @click="asyncSelect">确定</Button>
    </template>
  </Modal>
</template>
<script>
import { trim, isArray, debounce } from '@/common/js/utils'
import { getCaoHuaMedia } from '@/api/common.model'
export default {
  name: 'Manager',
  props: {
    value: {
      type: Boolean
    },
    type: {
      type: [Number, String]
    },
    operatorData: {
      type: Array
    }
  },
  computed: {
    visible: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  data() {
    return {
      loading: null,
      show: null,
      keyword: '',
      wide: 0,
      designerId: '',
      caohuaMedia: [],
      total: 0,
      pageIndex: 1,
      pageSize: 16
    }
  },
  methods: {
    filterQuery() {
      this.pageIndex = 1
      this.query()
    },
    query() {
      const { width, height } = this.getSize()
      if (width && typeof width !== 'number') this.$Message.warning('尺寸宽度不能是非数字')
      if (height && typeof height !== 'number') this.$Message.warning('尺寸高度不能是非数字')
      const params = {
        id: this.type,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        keyword: trim(this.keyword),
        designerId: this.designerId,
        width,
        height
      }
      getCaoHuaMedia(params).then((data) => {
        if (typeof data !== 'symbol') this.show = false
        if (data && isArray(data.list)) {
          this.caohuaMedia = data.list
          if (data.page_info) this.total = data.page_info.total_number
          else this.total = 0
        }
      })
    },
    getSize() {
      let width
      let height
      switch (this.wide) {
        case 1:
          width = 456
          height = 300
          break
        case 2:
          width = 1280
          height = 720
          break
        case 3:
          width = 720
          height = 1280
          break
        default:
          width = this.width || ''
          height = this.height || ''
          break
      }
      return { width, height }
    },
    debounce,
    bindGetData(e) {
      if (e) {
        this.query()
      } else {
        this.wide = 0
        this.openId = ''
      }
    },
    selectWrap(index) {
      this.caohuaMedia.forEach((ret, idx) => {
        this.$set(ret, 'check', idx === index)
      })
    },
    changePageIndex(index) {
      this.pageIndex = index
      this.query()
    },
    asyncSelect() {
      const selectWrap = this.caohuaMedia.filter((ret) => ret.check).pop()
      if (!selectWrap) {
        this.$Message.warning('您未选择一个媒体素材或选择的素材信息有误')
        return
      }

      this.$emit('on-select', selectWrap)
    }
  },
  filters: {
    fileSize(size) {
      if (typeof size !== 'number') return '0K'
      if (size > 104857) size = (size / 1048576).toFixed(2) + 'M'
      else if (size > 1000) size = (size / 1024).toFixed(2) + 'K'
      return size
    }
  }
}
</script>
<style lang="scss" scoped>
.image-box {
  overflow-y: auto;
  scrollbar-width: thin;
  -webkit-overflow-scrolling: touch;
  width: 100%;
  height: 570px;
  margin: 12px 0 0 0;

  .image-wrapper {
    display: inline-block;
    position: relative;

    .c-item-v,
    .c-item-img {
      display: inline-block;
      position: relative;
      margin: 0 5px 5px 5px;
      background-color: #efefef;
      overflow: hidden;
    }

    .c-item-v {
      height: 193px;
    }

    .image-check {
      display: inline-block;
      width: 24px;
      height: 24px;
      position: absolute;
      z-index: 9;
      top: 6px;
      right: 12px;
    }

    .image-item {
      width: 279px;
      height: 157px;
      position: relative;
      z-index: 2;
      display: flex;
      justify-content: center;
      align-items: center;

      img,
      video {
        width: auto;
        height: 100%;

        &.vertical-img {
          width: 100%;
          height: auto;
        }
      }

      .c-item-title {
        position: absolute;
        width: 100%;
        background-color: rgba(0, 0, 0, 0.6);
        color: #fff;
        right: 6px;
        line-height: 30px;
        bottom: 0;
        text-align: left;

        .c-hover-l {
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }

        .c-hover-r {
          text-align: right;
        }
      }

      .c-video-title {
        width: 100%;
        background-color: #000;
        color: #fff;
        text-align: left;
        line-height: 1;
        padding: 6px 0 6px 6px;

        p {
          margin: 0;
        }

        p.m-name {
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          width: 100%;
        }
      }

      .c-video-select {
        cursor: pointer;
        text-align: center;
        padding-top: 4px;

        .c-color-check {
          color: #00fa9a;
        }
      }

      .image-hover-txt {
        display: inline-block;
        height: 24px;
        line-height: 24px;
        position: absolute;
        top: 0px;
        left: 3px;
        color: #efefef;
        font-size: 13px;
        text-shadow: 2px 1px 1px #232323;
      }
    }

    &:hover {
      .image-hover-txt {
        opacity: 1;
      }
    }

    .image-item-large {
      width: 268px;
      height: 152px;
      text-align: center;
      background-color: #f2f2f2;
    }

    .c-item-bg {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: #3b3b3b;
      z-index: 1;
    }
  }
}

.page-index {
  margin-top: 12px;
  text-align: right;
}

::v-deep .ivu-btn {
  margin-left: 6px !important;
}

::v-deep .ivu-modal-body {
  padding-top: 8px;
}

::v-deep .ivu-form-item {
  margin-bottom: 0;
  text-align: left;
}

::v-deep .ivu-input-icon {
  width: 28px;
  height: 28px;
  line-height: 28px;
}

::v-deep .ivu-input {
  height: 28px;
}

::v-deep .el-input input {
  padding: 0 8px;
}

::v-deep .el-select__tags {
  padding-left: 4px;
}

::v-deep .el-select__input {
  margin-left: 2px;
}

::v-deep .el-select .el-tag {
  margin-left: 4px;
  display: flex;
  align-items: center;

  .el-select__tags-text {
    max-width: 78px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
}
</style>
